import arrowCircle from './arrow-circle.svg?raw';
import arrow from './arrow.svg?raw';
import check from './check.svg?raw';
import copy from './copy.svg?raw';
import squareDash from './square-dash.svg?raw';
import upDown from './up-down.svg?raw';

export default {
	check,
	arrow,
	arrowCircle,
	copy,
	squareDash,
	upDown,
};
